import {Button, ButtonProps} from "@progress/kendo-react-buttons"
import React, {MouseEventHandler} from "react";
import {Loader} from "@progress/kendo-react-indicators";
export default function FlintButton(props: buttonProps) {
    const {type = "button", className="me-1 text-wrap", showLoadingIcon = false, themeColor="primary",...other} = props;
    return <Button type={type} themeColor={themeColor}  className={className} {...other}>
        {showLoadingIcon ? <Loader className={className} size="medium" themeColor={themeColor == "primary" ? "light" : "primary"}/> : null}
        {props.children}
    </Button>
}

interface buttonProps extends ButtonProps{
    showLoadingIcon?:boolean;
}